export default "__VITE_ASSET__b8598c6d__"